// Vendors
import $ from 'jquery';

// Sub nav updates
const $subNavHome = $('.sub-nav--home');
const $subNavCustomMenu = $('.sub-nav--custom-menu');

if ($subNavHome.length && $subNavCustomMenu.length) {
  // modify markup
  $subNavHome
    .siblings('.sub-nav--item')
    .wrapAll("<div class='sub-nav--menu'></div>");
  $subNavHome.parent().wrapAll("<div class='sub-nav--item-container'></div>");

  $subNavHome.on('click', (event) => {
    const $currentTarget = event.target;

    // only slideToggle when div clicked
    if ($currentTarget.classList.contains('sub-nav--home')) {
      event.preventDefault();
      $('.sub-nav--menu').slideToggle();
    }
  });

  // disable Committee Materials click
  $('.sub-nav--item a').on('click', (event) => {
    if (event.currentTarget.innerHTML.includes('Committee Materials')) {
      event.preventDefault();
    }
  });
}

// Menu parents with a # URL act as disclosure buttons.
const $dropdownToggles = $('.sub-nav__toggle');

function closeDropdowns() {
  $dropdownToggles.attr('aria-expanded', 'false').parent().removeClass('is-open');
}

$dropdownToggles.on('click', (event) => {
  const $toggle = $(event.currentTarget);
  const open = $toggle.attr('aria-expanded') !== 'true';
  closeDropdowns();
  $toggle.attr('aria-expanded', String(open)).parent().toggleClass('is-open', open);
});

// Match the other navigation dropdowns on devices that support hover.
// Use the disclosure state so aria-expanded stays in sync with visibility.
$dropdownToggles.parent().on('mouseenter', (event) => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    return;
  }

  closeDropdowns();
  $(event.currentTarget).addClass('is-open').children('.sub-nav__toggle').attr('aria-expanded', 'true');
}).on('mouseleave', (event) => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    return;
  }

  $(event.currentTarget).removeClass('is-open').children('.sub-nav__toggle').attr('aria-expanded', 'false');
});

$(document).on('click', (event) => {
  if (!$(event.target).closest('.sub-nav--item').find('.sub-nav__toggle').length) {
    closeDropdowns();
  }
});

$dropdownToggles.parent().on('keydown', (event) => {
  if (event.key === 'Escape') {
    const $toggle = $(event.currentTarget).children('.sub-nav__toggle');
    closeDropdowns();
    $toggle.trigger('focus');
  }
}).on('focusout', (event) => {
  if (!event.currentTarget.contains(event.relatedTarget)) {
    $(event.currentTarget).removeClass('is-open').children('.sub-nav__toggle').attr('aria-expanded', 'false');
  }
});
